const contentful = require("contentful")

export const client = contentful.createClient({
    space: 'zcgdqdjnk9h8',
    accessToken: 'ojxwrwU0ETRxjZTsibwEUALQxI1o4zhLixFPlkS3_KI'
})
